/* Ziggy Cuts — product-media.js
   Product image carousel: horizontal scroll-snap (native swipe on mobile),
   prev/next arrows on desktop, and dot indicators synced to the active
   slide. No dependencies. */

(function () {
  'use strict';

  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('[data-gallery-track]');
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-gallery-slide]'));
    var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-dot]'));
    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    if (slides.length < 2) {
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
      return;
    }

    var current = 0;

    function setActive(i) {
      current = Math.max(0, Math.min(i, slides.length - 1));
      dots.forEach(function (d, di) {
        d.setAttribute('aria-current', di === current ? 'true' : 'false');
      });
      if (prev) prev.disabled = current === 0;
      if (next) next.disabled = current === slides.length - 1;
    }

    function goTo(i, smooth) {
      var target = slides[Math.max(0, Math.min(i, slides.length - 1))];
      track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    }

    // Sync active dot to whichever slide is centered in the track
    var scrollTimer = null;
    track.addEventListener('scroll', function () {
      if (scrollTimer) window.cancelAnimationFrame(scrollTimer);
      scrollTimer = window.requestAnimationFrame(function () {
        var center = track.scrollLeft + track.clientWidth / 2;
        var best = 0, bestDist = Infinity;
        slides.forEach(function (s, i) {
          var mid = s.offsetLeft - track.offsetLeft + s.clientWidth / 2;
          var d = Math.abs(mid - center);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        setActive(best);
      });
    }, { passive: true });

    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { goTo(i); });
    });
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });

    // Keyboard support
    gallery.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { goTo(current - 1); }
      else if (e.key === 'ArrowRight') { goTo(current + 1); }
    });

    // Jump to a scent's photo, preferring the closed (lid-on) shot.
    function goToScent(scent, smooth) {
      if (!scent) return;
      var firstMatch = -1;
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-scent') === scent) {
          if (firstMatch === -1) firstMatch = i;
          if (slides[i].getAttribute('data-state') !== 'open') { goTo(i, smooth); return; }
        }
      }
      if (firstMatch !== -1) goTo(firstMatch, smooth);
    }

    // When the shopper picks a scent, jump to that scent's photo.
    document.addEventListener('ziggy:variant', function (e) {
      goToScent(e.detail && e.detail.scent, true);
    });

    // ---------- Tap-to-zoom lightbox ----------
    var lightbox = document.querySelector('[data-lightbox]');
    if (lightbox) {
      var lbImg = lightbox.querySelector('[data-lightbox-img]');
      var lbPrev = lightbox.querySelector('[data-lightbox-prev]');
      var lbNext = lightbox.querySelector('[data-lightbox-next]');
      var lbIndex = 0;
      var lastFocus = null;

      var sources = slides.map(function (s) {
        var img = s.querySelector('img');
        return { src: img.getAttribute('data-full') || img.currentSrc || img.src, alt: img.alt };
      });

      function lbRender() {
        lbImg.src = sources[lbIndex].src;
        lbImg.alt = sources[lbIndex].alt;
        var multi = sources.length > 1;
        lbPrev.hidden = !multi;
        lbNext.hidden = !multi;
      }
      function lbOpen(i) {
        lbIndex = i;
        lastFocus = document.activeElement;
        lbRender();
        lightbox.hidden = false;
        document.body.style.overflow = 'hidden';
        requestAnimationFrame(function () { lightbox.classList.add('is-open'); });
        document.addEventListener('keydown', lbKey);
      }
      function lbClose() {
        lightbox.classList.remove('is-open');
        document.removeEventListener('keydown', lbKey);
        document.body.style.overflow = '';
        setTimeout(function () { lightbox.hidden = true; }, 250);
        if (lastFocus) lastFocus.focus();
      }
      function lbGo(d) { lbIndex = (lbIndex + d + sources.length) % sources.length; lbRender(); }
      function lbKey(e) {
        if (e.key === 'Escape') lbClose();
        else if (e.key === 'ArrowLeft') lbGo(-1);
        else if (e.key === 'ArrowRight') lbGo(1);
      }

      gallery.querySelectorAll('[data-gallery-zoom]').forEach(function (btn, i) {
        btn.addEventListener('click', function () { lbOpen(i); });
      });
      lightbox.querySelectorAll('[data-lightbox-close]').forEach(function (el) {
        el.addEventListener('click', lbClose);
      });
      lbPrev.addEventListener('click', function () { lbGo(-1); });
      lbNext.addEventListener('click', function () { lbGo(1); });

      // Swipe on mobile
      var sx = 0;
      lbImg.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      lbImg.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) lbGo(dx < 0 ? 1 : -1);
      }, { passive: true });
    }

    setActive(0);

    // On load, sync the gallery to the initially-selected scent (the variant
    // event may fire before this listener attaches), without animating.
    var pressed = document.querySelector('[data-option-index="0"] [aria-pressed="true"]');
    if (pressed) {
      var initScent = pressed.getAttribute('data-value');
      requestAnimationFrame(function () { goToScent(initScent, false); });
    }
  });

  // ---------- Sticky add-to-cart bar (mobile) ----------
  (function () {
    var bar = document.querySelector('[data-sticky-bar]');
    var buyBtn = document.querySelector('.product__buy');
    var stickyAdd = bar && bar.querySelector('[data-sticky-add]');
    var stickyPrice = bar && bar.querySelector('[data-sticky-price]');
    var form = document.querySelector('[data-product-form] form');
    if (!bar || !buyBtn || !form) return;

    // Reveal the bar only once the main buy button has scrolled out of view
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var visible = entries[0].isIntersecting;
        bar.hidden = false;
        bar.classList.toggle('is-visible', !visible);
      }, { rootMargin: '0px 0px -40% 0px' });
      io.observe(buyBtn);
    }

    stickyAdd.addEventListener('click', function () {
      if (stickyAdd.disabled) return;
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    });

    // Mirror price + availability from the main buy button on variant change
    document.addEventListener('ziggy:variant', function () {
      var price = document.querySelector('[data-product-price]');
      if (price && stickyPrice) stickyPrice.textContent = price.textContent;
      stickyAdd.disabled = buyBtn.disabled;
      stickyAdd.textContent = buyBtn.disabled ? stickyAdd.dataset.soldOutLabel : stickyAdd.dataset.label;
    });
  })();
})();
